module.exports = __webpack_public_path__ + "img/zonghe.07b3f890.png";